import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mobile-message",
  "use": "mobile-message-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"mobile-message\"><rect x=\"10.5\" y=\"25\" width=\"3\" height=\"3\" rx=\"1.5\" ry=\"1.5\" /><path d=\"M19 20v10H5V2h14v2h2V1a1 1 0 00-1-1H4a1 1 0 00-1 1v30a1 1 0 001 1h16a1 1 0 001-1V20z\" /><path d=\"M13 6v15l4-3h12V6zm11.33 9H16v-2h8.33zM26 11H16V9h10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/mobile-message.svg
// module id = CNCk
// module chunks = 39 44